import PropTypes from 'prop-types';
import { useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';

import { Flex } from '../grid';
import { P } from '../typography/new';
import { OrderAtTableCarousel } from '../carousel/order-at-table-carousel';

const FilterPicker = ({ filters, onClick, selected, highlightColor, ...rest }) => {
  const itemRefs = useRef({});

  const setItemRef = useCallback(
    filter => node => {
      itemRefs.current[filter] = node;
    },
    []
  );

  useEffect(() => {
    const node = itemRefs.current[selected];
    if (node) {
      node.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }, [selected]);

  return (
    <OrderAtTableCarousel hasMaxWidth={false} fullWidth justifyContent="center" gap="0px" {...rest}>
      {filters.map(filter => {
        const isSelected = filter === selected;

        return (
          <Flex
            ref={setItemRef(filter)}
            as="button"
            px="16px"
            onClick={() => onClick(filter)}
            type="button"
            key={filter}
            minWidth={{ md: '204px' }}
            selected={isSelected}
            justifyContent="center"
            height="49px"
            alignItems="center"
            position="relative"
          >
            <FilterOption
              variant="standard"
              data-testid={isSelected ? 'selected-filter-option' : 'filter-option'}
              selected={isSelected}
              fontWeight={isSelected ? '600' : 'normal'}
            >
              {filter}
            </FilterOption>
            <Flex
              width="100%"
              backgroundColor={isSelected ? highlightColor : 'grey40'}
              height={isSelected ? '4px' : '1px'}
              position="absolute"
              bottom="0"
            />
          </Flex>
        );
      })}
    </OrderAtTableCarousel>
  );
};

const FilterOption = styled(P)`
  white-space: nowrap;
`;

FilterPicker.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  highlightColor: PropTypes.string,
};

FilterPicker.defaultProps = {
  highlightColor: 'primaryRed',
};

export { FilterPicker };
